<template>
    <div class="main-container">
        <!-- <span class="input-label">Utilities > <b>Mass Communication Configurations</b></span> -->
        <breadcrumb :list="breadcrumbList" />
        <br><br><br>
        <under-construction></under-construction>
        <tl-tabs :tabs="tabs">
            <tl-tab>
                <div class="filters">
                    <tl-select label="Entity">
                    </tl-select>
                    <tl-select label="Paygroup">
                    </tl-select>
                </div>
                <div class="filters">
                    <tl-select label="Department">
                    </tl-select>
                    <tl-select label="Designation">
                    </tl-select>
                    <tl-select label="Employee Code">
                    </tl-select>
                    <tl-select label="Cost Center">
                    </tl-select>
                </div>
                <tl-header type="h2">Manage Preferences
                </tl-header>
                <div class="radio">
                 <tl-radio name="pref" label="Ess" id="pref1" value="ess" v-model="pref" />
                 <tl-radio name="pref" label="Email Id's" id="pref2" value="email" v-model="pref" />
                </div>
                <br><br>
                <div v-if="pref=='ess'">
                    <!-- <div class="filters"> -->
                    <tl-select
                        class="customwidth"
                        label="Select ESS Type"
                        :options="['Scroll On Homepage','Login Popup','Inbox']"
                        @change="(val)=>esstype(val)"
                        >
                        <!-- @change=""> -->
                    </tl-select>
                    <!-- </div> -->
                    <div v-if="esstypeval=='Login Popup' ||esstypeval=='Scroll On Homepage'">
                        <txt label="Enter Title"/>
                        <div class="txtarea">
                            <span class="input-label">Message</span>
                            <textarea rows="5" name="message">
                            </textarea>
                        </div>
                        <br>
                        <div class="filters">
                            <div class="txtarea">
                            <span class="input-label">Select Effective Date</span>
                            <date-picker/>
                            </div>
                            <tl-select
                            label="Select Time duration"
                            :options="['8 hours']"
                            />
                        </div>
                    </div>
                    <div v-else-if="esstypeval=='Inbox'">
                     <div class="txtarea">
                            <span class="input-label">Message</span>
                            <textarea rows="5" name="message">
                            </textarea>
                        </div>
                    </div>
                </div>
            <div v-else>
                 <txt label="Enter Title"/>
                 <br>
                <div class="txtarea">
                    <span class="input-label">Message</span>
                    <textarea rows="5" name="message">
                    </textarea>
                </div>
                <br>
                    <div class="radio">
                      <tl-radio name="email" label="Send Attachment to all" id="email1" value="attachment" v-model="email"/>
                      <tl-radio name="email" label="Manually Select Attachment for Employees" id="email2" value="manual" v-model="email"/>
                    </div>
                    <br><br>
                    <upload v-if="email=='attachment'" class="customwidth"/>
                     <data-table
                        v-if="email=='manual'"
                        :columns="employeeTableColumns"
                        :tableData="employeeData"
                        :checkbox="true"
                        :withForm="false"
                        @editStart="initEditStart"
                        @delete="deleteItem"
                        @update="updateItem"
                        :search="search"
                        :showinrow="false">
                        <template v-slot:rowcontent="slotprops">
                          <img class="sm-img"
                           v-if="slotprops.value.column.key=='imgSrc'"
                           :src="slotprops.value.record[slotprops.value.column.key]"
                           >
                          <p v-if="slotprops.value.column.key!='imgSrc' &&
                            slotprops.value.column.key!='attach' &&
                            slotprops.value.column.key!='removeattach'"
                            :class="{'filename': (slotprops.value.column.key=='attachname')}">
                              {{slotprops.value.record[slotprops.value.column.key]}}
                              </p>
                          <img v-if="slotprops.value.column.key=='attach'"
                             :src="slotprops.value.record[slotprops.value.column.key]"/>
                          <img v-if="slotprops.value.column.key=='removeattach'" :src="slotprops.value.record[slotprops.value.column.key]"/>
                        </template>
                    </data-table>
                </div>
            </tl-tab>
            <tl-tab>
                <span class="header2">Send notification of release of payslip</span>
                <br><br>
                <div class="radio">
                    <tl-checkbox label="Email Id"/>
                    <tl-checkbox label="SMS"/>
                </div>
                <br><br>
                <span class="header2">Send notification of IT declaration</span>
                <br><br>
                 <div class="radio">
                    <tl-checkbox label="Email Id"/>
                    <tl-checkbox label="SMS"/>
                </div>
                <br><br>Settings
                <span class="header2">Send notification of FBP declaration</span>
                <br><br>
                 <div class="radio">
                    <tl-checkbox label="Email Id"/>
                    <tl-checkbox label="SMS"/>
                </div>
            </tl-tab>
        </tl-tabs>
        <br><br>
        <bottom-action-container>
           <template slot="end">
            <btn-grp>
                <btn text="Cancel" type="secondary"/>
                <btn text="Next" type="primary"/>
            </btn-grp>
           </template>
        </bottom-action-container>
        </div>
</template>

<script>
export default {
  data(){
      return{
          underDevelopment: true,
          tabs: [{
            header: 'News & Announcements'
            },
            {
            header: 'More Options'
            }],
          pref: 'ess',
          email: 'attachment',
          esstypeval: '',
          employeeTableColumns: [
            {
            label: "",
            key: "imgSrc"
            },
            {
            label: "Code",
            key: "code"
            },
            {
            label: "Name",
            key: "name"
            },
            {
            label: "Department",
            key: "department"
            },
            {
            label: "Email ID",
            key: "email"
            },
            {
            label: "Location",
            key: "location"
            },
            {
            label: "ESS Status",
            key: "essstatus"
            },{
            label: "",
            key: "attach"
            },{
            label: "",
            key: "attachname"
            },
            {
            label: "",
            key: "removeattach"
            }
        ],
      employeeData: [
        {
          code: "RC1234",
          name: "Roxi",
          department: "IT",
          email: "Roxi@gmail.com",
          location: "Hyderabad",
          essstatus: "Active",
          imgSrc:require("@/assets/user.svg"),
          attach:require("@/assets/magnifying-glass.png"),
          attachname: 'abc3123.pdf',
          removeattach:require("@/assets/garbage.png")
        },
        {
          code: "RC1234",
          name: "Roxi",
          department: "IT",
          email: "Roxi@gmail.com",
          location: "Hyderabad",
          essstatus: "Active",
          imgSrc:require("@/assets/user.svg"),
          attach:require("@/assets/magnifying-glass.png")
        },
        {
          code: "RC1234",
          name: "Roxi",
          department: "IT",
          email: "Roxi@gmail.com",
          location: "Hyderabad",
          essstatus: "Active",
          imgSrc:require('@/assets/user.svg'),
          attach:require("@/assets/magnifying-glass.png")
        }
      ],
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/organisation`
        },
        {
          name: "Mass Communication Configurations",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/`
        }
      ]

      }
  },
  methods:{
      esstype(val){
          this.esstypeval=val
      }
  }
}
</script>

<style lang="scss" scoped>
.radio{
    display: flex;
    div{
    margin-right: 30px;
    }
}
.txtarea{
  display: flex;
  flex-direction: column;
  textarea{
    border-radius: 4px;
    border: 1px solid #dadada;
    padding: 10px;
    width: 645px;
    transition: ease-in-out, width 0.35s ease-in-out;
    &:focus {
        outline: none;
        border: 2px solid #34C0BE;
    }
  }
}
.customwidth{
    width: 300px;
}
.sm-img{
  width: 45%;
}
.filename{
  width: 200px;
}
</style>
